import { DeleteAccountDialog } from '@avanta/shared/components/DeleteAccountDialog';
import { Button } from '@avanta/shared/components/ui/Button';
import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { useTranslation } from 'react-i18next';
import { useUserStore } from 'stores/user';

export const DeleteAccount = (): React.ReactElement | null => {
  const { t } = useTranslation(LOCIZE_NS.PROFILE);
  const { showDialog } = useDialogContext();
  const user = useUserStore(state => state.user);
  const isEmployee = useUserStore(state => state.isEmployee);
  const isPatient = useUserStore(state => state.isPatient);
  const showDeleteAccount = isEmployee || isPatient;

  if (!showDeleteAccount) {
    return null;
  }

  return (
    <Card className="bg-white" title={t('DeleteAccount.heading')}>
      <Button
        className="w-fit text-red-500 hover:border-red-600 hover:bg-red-100"
        variant="terciary"
        onClick={() => showDialog({ component: <DeleteAccountDialog userId={user?.id} /> })}
      >
        <span>{t('DeleteAccount.cta')}</span>
      </Button>
    </Card>
  );
};
